import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'zignal-landscape/lib/Checkbox';
import Save2Icon from 'zignal-landscape/lib/Icon/Save2Icon';
import Remove2Icon from 'zignal-landscape/lib/Icon/Remove2Icon';
import WarningIcon from 'zignal-landscape/lib/Icon/WarningIcon';
import Label from 'zignal-landscape/lib/Label';
import themeable from 'zignal-landscape/lib/themeable';

import capitalize from 'lodash/capitalize';
import startCase from 'lodash/startCase';
import noop from 'lodash/noop';

const iconName = {
  positive: Save2Icon,
  negative: Remove2Icon,
  alert: WarningIcon
};

const CheckboxResultFilter = ({
  styles,
  id,
  type,
  label = startCase(id),
  checked = false,
  onChange = noop
}) => {

  const Icon = iconName[type];

  const capitalizedFilterType = capitalize(type);
  return (
    <div className={styles[`filter${capitalizedFilterType}`]}>
      <Checkbox
        id={id}
        name={id}
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.id)}
      />
      <span className={styles[`icon${capitalizedFilterType}`]}><Icon /></span>
      <Label htmlFor={id} inline>{label}</Label>
    </div>
  );
};

CheckboxResultFilter.propTypes = {
  styles: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['positive', 'negative', 'alert']),
  id: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,

};

export default themeable(CheckboxResultFilter);
